var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettings = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.378 12c0 3.312 2.695 6 6 6 3.312 0 6-2.688 6-6s-2.688-6-6-6c-3.311 0-6 2.688-6 6Zm1.512 0a4.489 4.489 0 1 1 8.977 0 4.494 4.494 0 0 1-4.489 4.495A4.498 4.498 0 0 1 7.89 12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.313 24h6.018l-.013-.007v-2.756c.49-.16.966-.352 1.422-.585l1.997 2.006 4.253-4.271-1.984-1.993c.224-.438.416-.903.575-1.375h2.797V8.974h-2.77a9.69 9.69 0 0 0-.602-1.461l1.898-1.907-4.253-4.27-1.911 1.919a9.762 9.762 0 0 0-1.415-.585V0H9.306v2.71c-.462.153-.919.346-1.355.571L6.013 1.335 1.761 5.606l1.95 1.96c-.224.458-.423.93-.575 1.415H.378v6.045h2.785c.145.458.33.896.549 1.328l-1.951 1.96 4.252 4.271 1.938-1.946c.443.226.893.418 1.362.571V24Zm4.47-1.554h-2.922V20.04l-.576-.153a8.13 8.13 0 0 1-2.07-.877L7.7 18.7l-1.68 1.687-2.063-2.072 1.687-1.694-.305-.518a8.005 8.005 0 0 1-.846-2.046l-.152-.578H1.926v-2.936h2.4l.146-.585a8.027 8.027 0 0 1 .866-2.125l.305-.518L3.956 5.62 6.02 3.547 7.7 5.234l.515-.312a7.895 7.895 0 0 1 2.07-.877l.576-.152V1.56h2.923v2.312l.588.146a8.283 8.283 0 0 1 2.13.877l.516.305 1.646-1.654 2.064 2.073-1.64 1.647.31.518c.404.678.701 1.408.893 2.166l.146.584h2.407v2.936h-2.42l-.152.578a8.15 8.15 0 0 1-.873 2.093l-.311.518 1.726 1.734-2.064 2.072-1.732-1.74-.516.305a8.056 8.056 0 0 1-2.13.877l-.588.146v2.392Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettings);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Settings.0eb5b4564741a920608139759175f312.svg";